import { useEffect, useRef } from 'react';
import EXHALE from '@/lib/testIds';

/**
 * TypingCanvas — a borderless, full-width textarea that grows with the text.
 * No outline on focus. No scrollbars. Just typing.
 */
export default function TypingCanvas({ value, onChange, placeholder, autoFocus = true, testId = EXHALE.canvas }) {
  const ref = useRef(null);

  // Auto-resize on every value change
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = `${Math.max(el.scrollHeight, 160)}px`;
  }, [value]);

  useEffect(() => {
    if (autoFocus && ref.current) {
      // Soft focus — wait a beat so the page transition finishes first
      const t = setTimeout(() => ref.current?.focus({ preventScroll: true }), 350);
      return () => clearTimeout(t);
    }
  }, [autoFocus]);

  return (
    <textarea
      ref={ref}
      data-testid={testId}
      className="exhale-canvas no-bar"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      spellCheck={false}
      autoCorrect="off"
      autoCapitalize="sentences"
    />
  );
}
